import { Locale } from 'signup-ui-lego-core/constants/Locale';
import { getApplicationLocale } from '../i18n/LocaleUtils';
const KnowledgeBaseLanguage = {
  [Locale.ja]: 'jp',
  [Locale.ptBr]: 'pt'
};
const HubSpotDotComLanguage = {
  [Locale.ja]: 'jp',
  [Locale.de]: 'de',
  [Locale.en]: 'com',
  [Locale.fr]: 'fr',
  [Locale.es]: 'es'
};
export const getKnowledgeBaseLink = (locale = getApplicationLocale()) => {
  let knowledgeArticleUrl = 'https://knowledge.hubspot.com';

  if (locale !== Locale.en) {
    const articleLanguage = KnowledgeBaseLanguage[locale] || locale;
    knowledgeArticleUrl = `${knowledgeArticleUrl}/${articleLanguage}`;
  }

  knowledgeArticleUrl = `${knowledgeArticleUrl}/account/hubspot-cloud-infrastructure-and-data-hosting-frequently-asked-questions`;
  return knowledgeArticleUrl;
};
export const getHubSpotDotComLink = (locale = getApplicationLocale()) => {
  const hubspotLink = `https://hubspot.`;

  if (locale === Locale.ptBr || locale === Locale.pt) {
    return 'https://br.hubspot.com';
  } else if (Object.keys(HubSpotDotComLanguage).includes(locale)) {
    return `${hubspotLink}${HubSpotDotComLanguage[locale]}`;
  }

  return `${hubspotLink}${HubSpotDotComLanguage[Locale.en]}`;
};